import { render } from "./CourseList.vue?vue&type=template&id=e0324b72"
import script from "./CourseList.vue?vue&type=script&lang=js"
export * from "./CourseList.vue?vue&type=script&lang=js"

import "./CourseList.vue?vue&type=style&index=0&id=e0324b72&lang=scss"

import exportComponent from "E:\\公司项目\\双碳\\gdtt-front\\gdtt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__